(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["logo-carousel"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeLogoCarousels = (scope = document) => {
      scope.querySelectorAll('[data-logo-carousel]').forEach((carousel) => {
        if (carousel.dataset.initialized === 'true') return;

        const track = carousel.querySelector('[data-logo-carousel-track]');
        const group = carousel.querySelector('[data-logo-carousel-group]');

        if (!track || !group) return;

        carousel.dataset.initialized = 'true';

        const updateCarousel = () => {
          const viewportWidth = carousel.offsetWidth;
          const groupWidth = group.scrollWidth;

          if (groupWidth <= viewportWidth) {
            track.classList.add('logo-carousel__track--static');
          } else {
            track.classList.remove('logo-carousel__track--static');
          }
        };

        updateCarousel();

        if ('ResizeObserver' in window) {
          const resizeObserver = new ResizeObserver(updateCarousel);
          resizeObserver.observe(carousel);
        } else {
          window.addEventListener('resize', updateCarousel);
        }
      });
    };

    initializeLogoCarousels();

    document.addEventListener('shopify:section:load', (event) => {
      initializeLogoCarousels(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
